import { getStyles } from './ScrollablePane.styles';
import { ScrollablePaneBase } from './ScrollablePane.base';
import { styled } from '../../Utilities';
export var ScrollablePane = styled(ScrollablePaneBase, getStyles, undefined, { scope: 'ScrollablePane' });
//# sourceMappingURL=ScrollablePane.js.map